import { useQuery } from "react-query"
import HeaderBar from "../../Components/UI/headerbar"
import StatsCard from "../../Components/UI/staticsCard"
import DataTable from "../../Components/UI/table/DataTable"
import FilterBar from "../../Components/UI/filterbar"
import { getUsers, getUsersStats } from "../../MyApi/user"
import { userColumns, userConfigStats } from "./config"

import { useState } from "react"

const UsersPage = () => {
  const [current_page, setCurrentPage] = useState(1)
const [filters, setFilters] = useState({
  search: "",
  status: "",
})

  const { data, isLoading, error, isFetching } = useQuery(
    ["getUser", current_page, filters],
    () => getUsers(current_page, filters),
    {
      keepPreviousData: true,
    }
  )
  
  const { data: statsUsersData, isLoading: isStatusLoading, refetch  } = useQuery("getUsersStats", getUsersStats)
  
  const users = data?.data?.users || []
  const total = data?.data?.pagination?.total || 0
  const last_page = data?.data?.pagination?.last_page
  const statsUsers = statsUsersData?.data?.stats || {}
  const userStats = userConfigStats(statsUsers)


const filtersConfig = {
  search: "search",
  is_active: "status",
  statusOptions: [
    { value: "active", label: "نشط" },
    { value: "inactive", label: "غير نشط" },
  ],
}
  const handleFilterChange = (newFilters) => {
    setCurrentPage(1) // Reset to first page when filters change
  }

  return (
    <div>
      <HeaderBar title="العملاء" content={"إدارة حسابات العملاء"} />

      <FilterBar
        setFilters={setFilters}
        filters={filters}
        filtersConfig={filtersConfig}
        onFilterChange={handleFilterChange}
        placeholder="البحث باسم المستخدم أو البريد الإلكتروني أو رقم الهاتف..."
      />

      <div className="row">
        {userStats.map((user, i) => (
          <div className="col-md" key={i}>
            <StatsCard {...user} isLoading={isStatusLoading} />
          </div>
        ))}
      </div>

      <DataTable 
        columns={userColumns} 
        data={users}
        isLoading={isLoading}
        totalItems={total}
        itemsPerPage={last_page}
        currentPage={current_page} 
        setCurrentPage={setCurrentPage}
        error={error} 
        onRetry={() => refetch()}
        isFetching={isFetching}
      />
    </div>
  )  
}

export default UsersPage
